.statusLegend {
  width: 0.9rem;
  height: 0.9rem;
  margin-right: 0.3rem;
  border-radius: 50%;
}

.large {
  width: 1.2rem;
  height: 1.2rem;
}

.green {
  background-color: var(--sentiment-positive-light);
}

.yellow {
  background-color: var(--sentiment-warning);
}

.red {
  color: var(--white);
  background-color: var(--sentiment-negative);
}

.gray {
  background-color: var(--gray-300);
}
